import { createSlice } from "@reduxjs/toolkit";
import {
  createRomm,
  getAllCandidates,
  getSingleInterview,
  myInterviews,
  saveNotesForInterviewer,
  updateInterviewStatus,
} from "./interviewAPI";

const initialState = {
  candidates: {
    data: [],
    loading: false,
    error: null,
  },
  interviews: {
    data: [],
    loading: false,
    error: null,
  },
  currentInterview: {
    data: null,
    loading: false,
    error: null,
  },
  createRoom: {
    loading: false,
    error: null,
    success: null,
  },
  updateStatus: {
    loading: false,
    error: null,
    success: null,
  },
  notes: {
    data: [],
    loading: false,
    error: null,
  },
  codeEditorCode: "your code goes here",
  codeLanguage: "javascript",
};

const interviewSlice = createSlice({
  name: "interview",
  initialState,
  reducers: {
    clearError: (state, action) => {
      const { section } = action.payload;
      if (state[section]) {
        state[section].error = null;
      }
    },
    clearSuccess: (state, action) => {
      const { section } = action.payload;
      if (state[section]) {
        state[section].success = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // get all candidates
      .addCase(getAllCandidates.pending, (state) => {
        state.candidates.loading = true;
        state.candidates.error = null;
      })
      .addCase(getAllCandidates.fulfilled, (state, action) => {
        state.candidates.loading = false;
        state.candidates.data = action.payload.candidates;
      })
      .addCase(getAllCandidates.rejected, (state, action) => {
        state.candidates.loading = false;
        state.candidates.error = action.payload?.rateLimitMsg || action.payload?.msg || 'Failed to fetch candidates';
      })

      // create interview rooms
      .addCase(createRomm.pending, (state) => {
        state.createRoom.loading = true;
        state.createRoom.error = null;
      })
      .addCase(createRomm.fulfilled, (state, action) => {
        state.createRoom.loading = false;
        state.createRoom.success = action.payload.msg;
      })
      .addCase(createRomm.rejected, (state, action) => {
        state.createRoom.loading = false;
        state.createRoom.error = action.payload?.msg || 'Failed to create room';
      })

      // get all my interviews (for both candidate and interviewer)
      .addCase(myInterviews.pending, (state) => {
        state.interviews.loading = true;
        state.interviews.error = null;
      })
      .addCase(myInterviews.fulfilled, (state, action) => {
        state.interviews.loading = false;
        state.interviews.data = action.payload.interviews;
      })
      .addCase(myInterviews.rejected, (state, action) => {
        state.interviews.loading = false;
        state.interviews.error = action.payload?.rateLimitMsg || action.payload?.msg || 'Failed to fetch interviews';
      })

      // update status

      .addCase(updateInterviewStatus.pending, (state) => {
        state.updateStatus.loading = true;
        state.updateStatus.error = null;
      })
      .addCase(updateInterviewStatus.fulfilled, (state, action) => {
        state.updateStatus.loading = false;
        state.updateStatus.success = action.payload.msg;
      })
      .addCase(updateInterviewStatus.rejected, (state, action) => {
        state.updateStatus.loading = false;
        state.updateStatus.error = action.payload?.rateLimitMsg || action.payload?.msg || 'Failed to update status';
      })

      // get single interview
      .addCase(getSingleInterview.pending, (state) => {
        state.currentInterview.loading = true;
        state.currentInterview.error = null;
      })
      .addCase(getSingleInterview.fulfilled, (state, action) => {
        state.currentInterview.loading = false;
        state.currentInterview.data = action.payload.interview;
        state.codeEditorCode = action.payload.interview.codeSnapshot;
        state.codeLanguage = action.payload.interview.codeLanguage;
        state.notes.data = action.payload.interview.notes;
      })
      .addCase(getSingleInterview.rejected, (state, action) => {
        state.currentInterview.loading = false;
        state.currentInterview.error = action.payload?.rateLimitMsg || action.payload?.msg || 'Failed to fetch interview';
      })

      // save notes for interviewer
      .addCase(saveNotesForInterviewer.pending, (state) => {
        state.notes.loading = true;
        state.notes.error = null;
      })
      .addCase(saveNotesForInterviewer.fulfilled, (state, action) => {
        state.notes.loading = false;
      })
      .addCase(saveNotesForInterviewer.rejected, (state, action) => {
        state.notes.loading = false;
        state.notes.error = action.payload?.msg || 'Failed to save notes';
      })
  },
});

export const { clearError, clearSuccess } = interviewSlice.actions;
export default interviewSlice.reducer;
